import { useEffect, useState, useContext } from "react";
import "./collabInviteModal.scss";
import { message, Modal } from "antd";
import { z, ZodType } from "zod";
import axios from "axios";

// context
import { AuthContext } from "../../contexts/authContext";

// icon
import { closeIcon } from "../../constants/icons";

interface CollabParameter {
  collabModal: boolean;
  setCollabModal: (arg: boolean) => void;
  evaluationId: string;
}


interface InviteFormData {
  evaluation_id: string;
  email: string;
  message: string;
}

const API_URL = "/api/v1"

const CollabInviteModal = ({
  evaluationId,
  collabModal,
  setCollabModal,
}: CollabParameter) => {
  const {setUser} = useContext(AuthContext);
  const [messageApi, contextHolder] = message.useMessage();
  const [inviteForm, setInviteForm] = useState<InviteFormData>({
    evaluation_id: evaluationId,
    email: "",
    message: "",
  });
  
  const [errorParams, setErrorParams] = useState({
    evaluation_id: false,
    email: false
  })

  const inviteFormSchema:ZodType<InviteFormData> = z.object({
    evaluation_id: z.string().min(10),
    email: z.string().email(),
    message: z.string()
  });
  const [loading, setLoading]=useState<boolean>(false);

  const resetForm = () =>{
    setInviteForm({
      ...inviteForm,
      email: "",
      message: ""
    })
    setErrorParams({
      evaluation_id: false,
      email:false
    })
    setCollabModal(false);
  }



  const handleFormValidation = () =>{
    let errordata:{
      evaluation_id: boolean,
      email: boolean
    } = {
      evaluation_id: false,
      email: false
    };
    const validation = inviteFormSchema.safeParse(inviteForm);
    if(!validation.success){
      const { errors } = validation.error;
      errors.forEach((err) => {
        if(err.path[0] === "email"){
          errordata.email = true
        }
        else if(err.path[0] === "evaluation_id"){
          errordata.evaluation_id = true
        }
      });
      setErrorParams(errordata);
      return false
    }
    return true
    
  }

  const handleFormSubmission = async() =>{
    try {
      setLoading(true);
      const validation = handleFormValidation();
      if(!validation){
        return false;
      }
      let formdata = {
        evaluation_id: evaluationId,
        email: inviteForm.email,
        message: inviteForm.message
      }
      const res = await axios.post(`${API_URL}/invite/collaborator`, formdata);
      if(res.status === 200 && res.data.success === true){
        messageApi.open({
          type: 'success',
          content: 'Your invitation has been sent successfully!',
        });
        resetForm()
      }

    } catch (error:any) {
      console.error("Error submitting invite form", error)
      if(error.response){
        const {status} = error.response;
        if(status === 401 || status === 500){
          setUser(null)
        }
      }
    }finally{
      setLoading(false);
    }
  }



  useEffect(()=>{
    setInviteForm({
      ...inviteForm,
      evaluation_id:evaluationId
    })
    // eslint-disable-next-line
  },[evaluationId])




  return (
    <Modal
      //   title="Invite collaborator to this evaluaition"
      centered
      open={collabModal}
      onCancel={()=>{
        resetForm()
      }}
      footer={null}
      closable={false}
      width={"700px"}
      styles={{
        body:{
          padding:0,
        },
        content:{
          padding:0
        }
      }}
    >{contextHolder}
      <div className="collabModalContainer">
        <div className="header">
          <span
            className="iconHolder"
            onClick={() =>{
              resetForm()
            }}
          >
            {closeIcon}
          </span>
          <span className="title">Invite collaborator to this evaluation</span>
          <div className="btnContainer">
            <button
              className="secondary"
              onClick={() => {
                resetForm();
              }}
            >
              Cancel
            </button>
            <button className="primary"
            onClick={handleFormSubmission}
            disabled={loading? true: false}
            >{loading? 'Sending...': 'Invite'}</button>
          </div>
        </div>
        <div className="bodyContainer">
          <span className="label">
            <span className="highlight">*</span> E-mail of the person you want
            to invite
          </span>
          <input
            id="email"
            type="email"
            value={inviteForm.email}
            onChange={(e) => {
              setInviteForm({
                ...inviteForm,
                email: e.target.value,
              });
              setErrorParams({
                ...errorParams,
                email:false
              })
            }}
            placeholder="i.e.: user@dblue.it"
            style={errorParams.email? {borderColor: "red"}: {borderColor: "#d9d9d9"}}
          />
          <span className="label">
            (Optional) Personalised message to the person invited:
          </span>
          <textarea
            id="message"
            placeholder="Here, type something you want to tell to the person you are inviting (i.e.: assign them a specific task)"
            value={inviteForm.message}
            onChange={(e) => {
              setInviteForm({
                ...inviteForm,
                message: e.target.value,
              });
            }}
          ></textarea>
        </div>
        <div className="footerBtnContainer">
          <button
            className="secondary"
            onClick={() =>{
              resetForm()
            }}
          >
            Cancel
          </button>
          <button className="primary"
          onClick={handleFormSubmission}
          disabled={loading? true: false}
          >Invite</button>
        </div>
      </div>
    </Modal>
  );
};

export default CollabInviteModal;
